// extracted by mini-css-extract-plugin
export default {"wrapper":"css_wrapper__sBJeC","title":"css_title__k80+c","list":"css_list__PXX9c"};